import React from 'react';

const NotFound = () => {
    return (
        <div className="w-100">
            <img className="w-100" src="https://colorlib.com/wp/wp-content/uploads/sites/2/404-error-page-templates.jpg" alt="" />
        </div>
    );
};

export default NotFound;